"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const query = (0, client_1.gql) `
 query allUserProfilesAdmin($query: UserProfileQueryInput, $pagination: PaginationInput ) {
  allUserProfilesAdmin(query: $query, pagination: $pagination) {
    _id
    userId
    imageUrl
    firstName
    lastName
    email
    phoneNumber
    stripeCustomerId
    organization{
        orgName
        _id
    }
    __typename
  }
}
`;
exports.default = query;
//# sourceMappingURL=superAdminAllCustomer.query.js.map